export const promoStatuses = {
  1: "Черновик",
  2: "Запущена",
  3: "Отменена",
  5: "Завершена"
};